import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=fbe99b2e&scoped=true"
var script = {}
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=fbe99b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe99b2e",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QIcon});
